import React, { Component } from "react";

import { addValidationRule, withFormsy } from "formsy-react";
import { ControlLabel, Panel, Button, Glyphicon, Checkbox } from "react-bootstrap";
import Select from "react-select";

import FormInput from "../../../components/common/elements/FormInput";
import TextareaWithLabel from "../../../components/common/elements/TextareaWithLabel";
import AutocompleteInput from "../../../components/common/elements/AutocompleteInput";
import rolesConf from "../../../config/roles";
import translator from "../../../components/localization/translator";
import { generateApiToken, createTemporaryPassword, getTemporaryPasswordTime } from "../../Admin/admin.actions";
import RadioGroup from "../../../components/common/elements/RadioGroup";
import {
    DISTRIBUTOR_COOPERATION_TYPES,
    DISTRIBUTOR_TERMINAL_TYPES,
    SUPPLIER_USER_TYPE_NAMES, SUPPLIER_USER_TYPES,
} from "../../../config/constants";
import moment from "moment";
import security from "../../../components/common/security/security";
import { USER_ROLES } from "../../../config/constants";

function createPercentageValidationRule(fieldName) {
    return (values, value) => {
        const actualValue = value || (values && values[fieldName]);

        // Allow empty values since field is not required
        if (actualValue === "" || actualValue === undefined || actualValue === null) {
            return true;
        }

        const numValue = Number(actualValue);

        if (isNaN(numValue)) {
            return false; // Invalid number
        }
        if (numValue < 0) {
            return false; // Below minimum
        }
        if (numValue > 100) {
            return false; // Above maximum
        }

        return true; // Valid number within range
    };
}


addValidationRule("receivableLimit", createPercentageValidationRule("receivableLimit"));
addValidationRule("tipShare", createPercentageValidationRule("tipShare"));

addValidationRule("passwordMatch", (values, value) => {
    return values.password === value;
});

addValidationRule("min", (minValue, value) => {
    const numValue = Number(value);
    return !isNaN(numValue) && numValue >= Number(minValue);
});

addValidationRule("max", (maxValue, value) => {
    const numValue = Number(value);
    return !isNaN(numValue) && numValue <= Number(maxValue);
});

class EditableField extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: this.props.userDetails.user.username,
            name: this.props.userDetails.user.name,
            email: this.props.userDetails.user.email,
            softPosEmail: this.props.userDetails.user.softPosEmail,
            legalEmailAddress: this.props.userDetails.user.legalEmailAddress,
            individualEntrepreneurName: this.props.userDetails.user.individualEntrepreneurName,
            taxpayerIdentificationNumber: this.props.userDetails.user.taxpayerIdentificationNumber,
            taxPayerChargingAmount: this.props.userDetails.user.taxPayerChargingAmount,
            partner: this.props.userDetails.user.partner,
            extra: this.props.userDetails.user.extra && this.props.userDetails.user.extra.length ? this.props.userDetails.user.extra : [{}],
            branch: this.props.userDetails.user.branch,
            isCallCenter: this.props.userDetails.user.isCallCenter || false,
            terminalId: this.props.userDetails.user.terminalId,
            // companyTin: this.props.userDetails.user.companyTin,
            address: this.props.userDetails.user.address,
            legalAddress: this.props.userDetails.user.legalAddress,
            taxRegime: this.props.userDetails.user.taxRegime,
            crn: this.props.userDetails.user.crn,
            sn: this.props.userDetails.user.sn,
            dep: this.props.userDetails.user.dep,
            cashierId: this.props.userDetails.user.cashierId,
            phone: this.props.userDetails.user.phone,
            // tariff: this.props.userDetails.user.tariff,
            area: this.props.userDetails.user.area,
            areaName: this.props.userDetails.user.areaName,
            receivableLimit: this.props.userDetails.user.receivableLimit || 0,
            tipShare: this.props.userDetails.user.tipShare || 0,
            // tipShareEffectiveDate: this.props.userDetails.user.tipShareEffectiveDate
            //     ? moment(this.props.userDetails.user.tipShareEffectiveDate).format("YYYY-MM-DD")
            //     : null,
            accessToken: this.props.userDetails.user.accessToken,
            accessList: this.props.userDetails.user.accessList,
            baseUrl: this.props.userDetails.user.baseUrl,
            apiUser: this.props.userDetails.user.apiUser,
            createOrder: this.props.userDetails.user.createOrder,
            updateOrder: this.props.userDetails.user.updateOrder,
            cancelOrder: this.props.userDetails.user.cancelOrder,
            authUserName: this.props.userDetails.user.authUserName,
            authPassword: this.props.userDetails.user.authPassword,
            distributionPartner: this.props.userDetails.user.distributionPartner,
            availableDebt: this.props.userDetails.user.availableDebt,
            getStatus: this.props.userDetails.user.getStatus,
            distributorCooperationType: this.props.userDetails.user.distributorCooperationType,
            fundDeposit: this.props.userDetails.user.fundDeposit || false,
            isHzorUser: this.props.userDetails.user.isHzorUser || false,
            chargingAmount: this.props.userDetails.user.chargingAmount || 0,
            chargingBalance: this.props.userDetails.user.chargingBalance || 0,
            salaryFundDeposit: this.props.userDetails.user.salaryFundDeposit || false,
            salaryChargingAmount: this.props.userDetails.user.salaryChargingAmount || 0,
            salaryChargingBalance: this.props.userDetails.user.salaryChargingBalance || 0,
            saveDeposit: this.props.userDetails.user.saveDeposit || false,
            saveDepositAmount: this.props.userDetails.user.saveDepositAmount || 0,
            saveDepositTotal: this.props.userDetails.user.saveDepositTotal || 0,
            tin: this.props.userDetails.user.tin,
            posTerminalId: this.props.userDetails.user.posTerminalId || 0,
            providedTransport: this.props.userDetails.user.providedTransport || "",
            bag: this.props.userDetails.user.bag || null,
            posTerminalType: this.props.userDetails.user.posTerminalType || null,
            contractDate: this.props.userDetails.user.contractDate
                ? moment(this.props.userDetails.user.contractDate).format("YYYY-MM-DD")
                : null,
            transportProvidedDate: this.props.userDetails.user.transportProvidedDate
                ? moment(this.props.userDetails.user.transportProvidedDate).format("YYYY-MM-DD")
                : null,
            bagProvidedDate: this.props.userDetails.user.bagProvidedDate
                ? moment(this.props.userDetails.user.bagProvidedDate).format("YYYY-MM-DD")
                : null,
            posProvidedDate: this.props.userDetails.user.posProvidedDate
                ? moment(this.props.userDetails.user.posProvidedDate).format("YYYY-MM-DD")
                : null,
            userType: this.props.userDetails.user.userType || "",
            temporaryPassword: this.props.userDetails.user.temporaryPassword || "",
            tempPassActiveTime: this.props.userDetails.user?.tempPassActiveTime,
            expiresAt: this.props.userDetails.user?.expiresAt,
            passwordFieldVisible: {},
        };
    }

    componentDidMount() {
        this.fetchTemporaryPasswordTime();
        this.countdownInterval = setInterval(() => {
            if (this.state.tempPassActiveTime) {
                this.forceUpdate();
            }
        }, 1000);
    }

    fetchTemporaryPasswordTime = async () => {
        const { user } = this.props.userDetails;
        if (!user || !user._id || user.role !== 10) return;
        try {
            const data = await getTemporaryPasswordTime(user._id);
            this.setState({ tempPassActiveTime: data.tempPassActiveTime, expiresAt: data.expiresAt });
        } catch (e) {
            // no active temporary password
        }
    };

    componentWillUnmount() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }

    getTaxRegimeOptions() {
        return [
            { value: 1, label: "ԱԱՀ-ով հարկվող" },
            { value: 2, label: "ԱԱՀ-ով չհարկվող" },
            { value: 3, label: "Շրջանառության հարկ վճարող" },
            { value: 7, label: "Միկրոձեռնարկատիրություն" },
        ];
    }

    renderTaxRegimeField(field, id) {
        const { key } = field;
        const options = this.getTaxRegimeOptions();
        const currentValue = this.state[key];
        const selectedOption = options.find(o => o.value === currentValue) || null;
        return (
            <div key={id} className="display-flex align-center">
                <ControlLabel htmlFor={key} className={"label-width"}>{translator.translate(field.title)}</ControlLabel>
                <Select
                    className={"my-custom-input"}
                    onChange={target => {
                        const value = target ? target.value : null;
                        this.setState({ [key]: value });
                        this.props.setChangedData(key, value);
                    }}
                    options={options}
                    placeholder={translator.translate(field.title)}
                    value={selectedOption}
                    isClearable
                />
            </div>
        );
    }

    getSelectedPartner() {
        const partnerId = this.state.partner;
        const partner = (this.props.partners || []).find(partner => partner._id === partnerId);
        return partner ? {
            ...partner,
            branches: partner.branches ? partner.branches.filter(branch => !branch.deleted) : [],
        } : {};
    }

    getSelectedBranch() {
        const selectedPartner = this.getSelectedPartner();
        const branchId = this.state.branch;
        if (!selectedPartner._id) {
            return {};
        }
        return selectedPartner.branches.find(branch => branch._id === branchId) || {};
    }

    getSelectedTariff() {
        const tariffName = this.state.tariff;
        return (this.props.tariffs || []).find(tariff => tariff.name === tariffName) || {};
    }

    getSelectedArea() {
        const areaId = this.state.area;
        return (this.props.areas || []).find(area => area._id === areaId) || {};
    }

    getSelectedApiUser() {
        const selectedApiUser = this.state.apiUser;
        return ((this.props.apiUsers || {}).users || []).find(apiUser => apiUser._id === selectedApiUser || apiUser.name === selectedApiUser) || {};
    }

    renderAutocompleteInput(id, key, value, label, onChange, items) {
        return (<div key={id} className="display-flex">
            <ControlLabel htmlFor={key} className={"label-width"}>{translator.translate(label)}</ControlLabel>
            <div className="my-custom-input">
                <AutocompleteInput
                    items={items}
                    value={value}
                    onChange={onChange}
                />
                {!value && <div className="validation-error distance-field default-font red-color">
                    {translator.translate("_choose_autocomplete_")}
                </div>}
            </div>
        </div>);
    }

    renderUserTypeField(field, id) {
        const { key } = field;
        const value = this.state[key] || "";

        return (
            <div className="display-flex align-items-center role-wrapper">
                <ControlLabel htmlFor={key} className="label-width">{translator.translate(field.title)}</ControlLabel>
                <div className="role-select-wrapper">
                    <select
                        className="form-control role-select"
                        name={key}
                        value={value}
                        onChange={(e) => {
                            const userTypeValue = e.target.value;
                            this.setState({ [key]: userTypeValue });
                            this.props.setChangedData(key, userTypeValue);
                        }}
                        required
                    >
                        <option value="" disabled style={{ fontStyle: "italic" }}>
                            {translator.translate("Ընտրել օգտատիրոջ տեսակը")}
                        </option>
                        {SUPPLIER_USER_TYPE_NAMES.map((userTypeItem) => (
                            <option
                                key={userTypeItem.value}
                                value={userTypeItem.value}
                                disabled={userTypeItem.disabled}
                            >
                                {translator.translate(userTypeItem.label)}
                            </option>
                        ))}
                    </select>
                    {!value && <div className="validation-error distance-field default-font red-color">
                        {translator.translate("Պարտադիր դաշտ")}
                    </div>}
                </div>
            </div>
        );
    }

    renderPartnerField(field, id) {
        const { key } = field;
        const value = this.getSelectedPartner().name || "";
        return this.renderAutocompleteInput(id, key, value, field.title, (list) => {
            let partner = "";
            if (list.length) {
                partner = list[0]._id;
            }
            this.setState({ [key]: partner });
            this.props.setChangedData(key, partner);
        }, this.props.partners || []);
    }

    renderExtraAutoCompleteInput(item, index, id, field) {
        const dist = item.partner ? (this.props.partners || []).find(partner => partner._id == item.partner) : "";
        const selectedBranch = dist && (dist.branches || []).find(branch => branch._id === item.branch) || {};
        const value = dist.name || "";
        const branchValue = selectedBranch.name || "";
        const branchList = dist && (dist.branches || []).filter(branch => !branch.deleted) || [];
        return (
            <React.Fragment key={id + index}>
                <div className="display-flex">

                    <ControlLabel htmlFor={field.key} className={"label-width"}>{translator.translate(field.title)}
                        <span
                            className={`glyphicon glyphicon-${index == 0 ? "plus" : "minus"}-sign align-center left-distance red-color pointer`}
                            onClick={(e) => {
                                if (index == 0) {
                                    this.setState({ extra: [...this.state.extra, {}] });
                                } else {
                                    this.setState({ extra: this.state.extra.filter((e, i) => i != index) });
                                    this.props.setChangedData("extra", this.state.extra.filter((e, i) => i != index));
                                }
                            }}>
							</span>
                    </ControlLabel>

                    <div className="my-custom-input">
                        <AutocompleteInput
                            items={this.props.partners}
                            value={value}
                            onChange={(list) => {
                                let extraPartner = "";
                                if (list.length) {
                                    extraPartner = list[0]._id;
                                }

                                const newExtra = this.state.extra.map((item, idx) => {
                                    if (idx == index) {
                                        return {
                                            partner: extraPartner,
                                        };
                                    }
                                    return item;
                                });
                                this.setState({ extra: newExtra });
                                this.props.setChangedData("extra", newExtra);
                            }}
                        />
                    </div>
                </div>
                {(value && !!branchList.length) &&
                    <div className="display-flex">
                        <ControlLabel className={"label-width"}>{translator.translate("_branch_")}</ControlLabel>
                        <div className="my-custom-input">
                            <AutocompleteInput
                                items={branchList}
                                value={branchValue}
                                onChange={(list) => {
                                    let branch = "";
                                    if (list.length) {
                                        branch = list[0]._id;
                                    }
                                    const newExtra = this.state.extra.map((item, idx) => {
                                        if (idx == index) {
                                            return {
                                                ...item,
                                                branch,
                                            };
                                        }
                                        return item;
                                    });
                                    this.setState({ extra: newExtra });
                                    this.props.setChangedData("extra", newExtra);
                                }}
                            />
                        </div>
                    </div>

                }
            </React.Fragment>

        );
    }

    renderExtraFields(field, id) {
        if (!this.getSelectedPartner().name || this.state.isCallCenter) {
            return;
        }
        return this.state.extra.map((e, i) => {
            return this.renderExtraAutoCompleteInput(e, i, id, field);
        });
    }

    getSelectedDistributionPartner() {
        const distributionPartnerId = this.state.distributionPartner;
        return (this.props.distributionPartners || []).find(partner => partner._id === distributionPartnerId) || {};
    }

    renderDistributionPartnerField(field, id) {
        const { key } = field;
        const value = this.getSelectedDistributionPartner().name || "";

        return this.renderAutocompleteInput(id, key, value, field.title, (list) => {
            let distributionPartner = "";
            if (list.length) {
                distributionPartner = list[0]._id;
            }
            this.setState({ [key]: distributionPartner });
            this.props.setChangedData(key, distributionPartner);
        }, [{
            _id: "",
            name: translator.translate("_choose_"),
        }, ...(this.props.distributionPartners || []).filter(user => !user.isDeactive)]);
    }

    renderBranchField(field, id) {
        const { key } = field;
        const selectedPartner = this.getSelectedPartner();
        if (!selectedPartner._id || !selectedPartner.branches.length || this.state.isCallCenter) {
            return null;
        }
        const selectedBranch = this.getSelectedBranch();
        const value = selectedBranch.name || "";
        return this.renderAutocompleteInput(id, key, value, field.title, (list) => {
            let branch = "";
            if (list.length) {
                branch = list[0]._id;
            }
            this.setState({ [key]: branch });
            this.props.setChangedData(key, branch);
        }, selectedPartner.branches);
    }

    renderContractDate(field, id) {
        const { key } = field;
        const value = this.state[key] || "";

        return (
            <div key={id} className="display-flex align-center">
                <ControlLabel htmlFor={key} className={"label-width"}>{translator.translate(field.title)}</ControlLabel>
                <FormInput
                    type="date"
                    id={key}
                    name={key}
                    value={value}
                    onChange={(e) => {
                        this.setState({ [key]: e.target.value });
                        this.props.setChangedData(key, e.target.value);
                    }}
                    onBlur={(e) => {
                        this.props.onBlur(key, e.target.value);
                    }}
                />
            </div>
        );
    }

    renderBranchCallCenterField(field, id) {
        const { key, title } = field;
        const selectedPartner = this.getSelectedPartner();
        if (!selectedPartner._id || !selectedPartner.branches.length || this.state.branch) {
            return null;
        }

        return (
            <div key={key} className="display-flex align-center">
                {title ? <label htmlFor={this.props.htmlFor}
                                className={"label-width"}>{translator.translate(title)}</label> : null}
                <Checkbox
                    className={"my-custom-input"}
                    onChange={event => {
                        const { target } = event;
                        this.setState({ [key]: target.checked });
                        this.props.setChangedData(key, target.checked);
                    }}
                    checked={this.state[key]}
                />
            </div>
        );


    }

    renderTariffField(field, id) {
        const { key } = field;
        const selectedTariff = this.getSelectedTariff();
        const value = selectedTariff.name || "";
        this.props.setChangedData(key, selectedTariff._id);
        // return this.renderAutocompleteInput(id, key, value, field.title, (list) => {
        //     let tariff = "";
        //     let tariffName = "";
        //     let distributorType = "";
        //     if (list.length) {
        //         tariff = list[0]._id;
        //         tariffName = list[0].name;
        //         distributorType = list[0].distributorType;
        //     }
        //     if (value) {
        //         this.props.disableButton();
        //     } else {
        //         this.props.enableButton();
        //     }
        //     if (!tariff) {
        //         this.props.setChangedData("tariff", "");
        //         this.setState({ "tariff": "" });
        //     }
        //     this.setState({ [key]: tariffName });
        //     this.props.setChangedData(key, tariff);
        //     this.props.setChangedData("type", distributorType);
        //     if (selectedTariff && selectedTariff.name != tariffName) {
        //         this.props.setChangedData("tariffChanged", true);
        //     }
        // }, this.props.tariffs);
    }

    renderAreaField(field, id) {
        const { key } = field;
        const selectedArea = this.getSelectedArea();
        const value = selectedArea.name || "";
        this.props.setChangedData(key, selectedArea._id);
        return this.renderAutocompleteInput(id, key, value, field.title, (list) => {
            let area = "";
            let areaName = "";
            if (list.length) {
                area = list[0]._id;
                areaName = list[0].name;
            }
            if (!area) {
                this.props.setChangedData("area", "");
                this.props.setChangedData("areaName", "");
                this.setState({ "area": "", areaName: "" });
            }
            this.setState({ [key]: area, areaName: areaName });
            this.props.setChangedData(key, area);
            this.props.setChangedData("areaName", areaName);
        }, this.props.areas || []);
    }

    renderApiUserField(field, id) {
        const { key } = field;
        const selectedApiUser = this.getSelectedApiUser();
        const value = selectedApiUser.name || "";
        this.props.setChangedData(key, selectedApiUser._id);
        return this.renderAutocompleteInput(id, key, value, field.title, (list) => {
            let apiUser = "";
            let apiUserName = "";
            if (list.length) {
                apiUser = list[0]._id;
                apiUserName = list[0].name;
            }
            if (!apiUser) {
                this.props.setChangedData("apiUser", "");
                this.setState({ "apiUser": "" });
            }
            this.setState({ [key]: apiUserName });
            this.props.setChangedData(key, apiUser);
        }, ((this.props.apiUsers || {}).users || []).filter(user => !user.isDeactive));
    }

    renderDistributorCooperationTypes(field, id) {
        const { key } = field;
        return (
            <div key={id} className="display-flex justify-content-between align-items-center">
                <ControlLabel htmlFor={key}
                              className={"label-width"}>{translator.translate(field.title)}:</ControlLabel>
                <div className="distributor-cooperation-types">
                    {Object.values(DISTRIBUTOR_COOPERATION_TYPES).map(cooperationType => {
                        return <RadioGroup
                            id={`cooperationType-${cooperationType.id}`}
                            name={"cooperationType"}
                            key={cooperationType.id}
                            title={translator.translate(cooperationType.title)}
                            value={cooperationType.id}
                            checked={this.state.distributorCooperationType ? this.state.distributorCooperationType === cooperationType.id : cooperationType.isDefault}
                            onClick={(e) => {
                                this.props.setChangedData(key, e.target.value);
                            }}
                            customClass="margin-to-right"
                            customRadioClass="to-right"
                            customRadioSpanClass="inline-block" />;
                    })}
                </div>
            </div>
        );
    }

    renderTerminalType(field, id) {
        if (!this.state.posTerminalId) {
            return null;
        }
        const { key } = field;
        return <div key={id} className="display-flex">
            <ControlLabel htmlFor={key} className={"label-width"}>{translator.translate(field.title)}</ControlLabel>
            <div className="distributor-cooperation-types">
                {Object.values(DISTRIBUTOR_TERMINAL_TYPES).map(terminalType => {
                    return <RadioGroup
                        id={`terminalType-${terminalType.id}`}
                        name={"terminalType"}
                        key={terminalType.id}
                        title={translator.translate(terminalType.title)}
                        value={terminalType.id}
                        checked={this.state.posTerminalType ? this.state.posTerminalType === terminalType.id : terminalType.isDefault}
                        onClick={(e) => {
                            this.props.setChangedData(key, e.target.value);
                        }}
                        customClass="margin-to-right"
                        customRadioClass="to-right"
                        customRadioSpanClass="inline-block" />;
                })}
            </div>
        </div>;
    }

    // renderCompanyTin(field, id) {
    //     const label = field.title,
    //         value = this.state.companyTin,
    //         company = value ? COMPANY.getCompanyByTin(value) : null ;
    //     return (
    //         <div key={label} className="display-flex align-center">
    //             {label ? <label htmlFor={this.props.htmlFor} className={'label-width'}>{translator.translate(label)}</label> : null}
    //             <Select
    //                 className={label ? 'my-custom-input' : ''}
    //                 onChange={target => {
    //                     if (this.props.isNew && !this.state.terminalId) {
    //                         this.props.getTerminalId((res) => {
    //                             this.setState({ terminalId: res.terminalId });
    //                             this.props.setChangedData('terminalId', res.terminalId);
    //                         });
    //                     }
    //                     this.setState({ companyTin: target.value});
    //                     this.props.setChangedData(field.key, target.value);
    //                 }}
    //                 options={COMPANY.companies('label', 'tin')}
    //                 required={'required'}
    //                 // validations={validations}
    //                 placeholder={translator.translate(label)}
    //                 value={company ? {
    //                     label: company.name,
    //                     value: value
    //                 } : null}
    //             />
    //         </div>
    //     );
    // }

    renderCheckbox(field, id) {
        const label = field.title,
            key = field.key;
        return (
            <div key={key} className="display-flex align-center">
                {label ? <label htmlFor={this.props.htmlFor}
                                className={"label-width"}>{translator.translate(label)}</label> : null}
                <Checkbox
                    className={"my-custom-input"}
                    onChange={event => {
                        const { target } = event;
                        this.setState({ [key]: target.checked });
                        this.props.setChangedData(key, target.checked);
                    }}
                    checked={this.state[key]}
                />
            </div>
        );
    }

    percentageInput(field, id) {
        const key = field.key;
        const isTipShare = key === "tipShare";
        const tipShareValue = this.state.tipShare;
        const effectiveDateValue = this.state.tipShareEffectiveDate || "";
        const today = moment().format("YYYY-MM-DD");
        const effectiveDateRequired = tipShareValue !== "" && tipShareValue != null;
        const showEffectiveDateError = isTipShare && effectiveDateRequired && !effectiveDateValue;

        return (
            <div key={id} className="display-flex">
                <ControlLabel htmlFor={key} className={"label-width"}>{translator.translate(field.title)}</ControlLabel>
                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <FormInput
                            type="number"
                            id={key}
                            name={key}
                            value={this.state[key] || ""}
                            onChange={(e) => {
                                const value = e.target.value;
                                this.setState({ [key]: value });
                                this.props.setChangedData(key, Number(value) || 0);
                                if (isTipShare && value === "") {
                                    this.setState({ tipShareEffectiveDate: null });
                                    this.props.setChangedData("tipShareEffectiveDate", null);
                                }
                            }}
                            onBlur={(e) => {
                                this.props.onBlur(key, e.target.value);
                            }}
                            validations={field.canChange.validations}
                            validationErrors={field.canChange.validationErrors}
                            required={field.isRequired === false ? false : (this.props.isNew ? true : !field.canChange.isPassword)}
                            disabled={field.isDisabled && this.props.isNew}
                            placeholder="0"
                            min="0"
                            max="100"
                        />
                        <span style={{ marginLeft: "8px", fontWeight: "bold" }}>%</span>
                    </div>
                    {/*{isTipShare && (*/}
                    {/*    <div style={{ display: "flex", flexDirection: "column" }}>*/}
                    {/*        <div style={{ display: "flex", alignItems: "center" }}>*/}
                    {/*            <ControlLabel htmlFor="tipShareEffectiveDate" style={{ marginRight: "8px", marginBottom: 0, whiteSpace: "nowrap" }}>*/}
                    {/*                {translator.translate("_effective_date_", "Կիրառման սկիզբ")}*/}
                    {/*            </ControlLabel>*/}
                    {/*            <FormInput*/}
                    {/*                type="date"*/}
                    {/*                id="tipShareEffectiveDate"*/}
                    {/*                name="tipShareEffectiveDate"*/}
                    {/*                value={effectiveDateValue}*/}
                    {/*                min={today}*/}
                    {/*                onChange={(e) => {*/}
                    {/*                    const value = e.target.value;*/}
                    {/*                    this.setState({ tipShareEffectiveDate: value || null });*/}
                    {/*                    this.props.setChangedData("tipShareEffectiveDate", value || null);*/}
                    {/*                }}*/}
                    {/*                onBlur={(e) => {*/}
                    {/*                    this.props.onBlur("tipShareEffectiveDate", e.target.value);*/}
                    {/*                }}*/}
                    {/*                required={effectiveDateRequired}*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*        {showEffectiveDateError && (*/}
                    {/*            <div className="validation-error default-font red-color" style={{ marginTop: "4px" }}>*/}
                    {/*                {translator.translate("_field_required_", "Պարտադիր դաշտ.")}*/}
                    {/*            </div>*/}
                    {/*        )}*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </div>
            </div>
        );
    }

    generateToken = () => {
        const { user } = this.props.userDetails;
        if (user && user._id) {
            generateApiToken(user._id, ({ data: { accessToken } = {} }) => {
                if (accessToken) {
                    this.setState({ accessToken });
                    this.props.setChangedData("accessToken", accessToken);
                }
            });
        }
    };

    createTemporaryPassword = async () => {
        const { user } = this.props.userDetails;
        if (!user || !user._id) return;

        const password = this.state.temporaryPassword;

        const { data } = await createTemporaryPassword(user._id, password);

        this.setState({ tempPassActiveTime: data.tempPassActiveTime, expiresAt: data.expiresAt });

        return { password, ...data };
    };

    renderAccessToken(field) {
        const { user } = this.props.userDetails;
        const { key, title } = field;
        const token = this.state[field.key] || "";
        return (<Panel className="w-100" key={key}>
            <Panel.Heading>
                {translator.translate(title)}
                <Button bsStyle="link" disabled={!user || !user._id} onClick={this.generateToken}>
                    {translator.translate("_re_generate_")}
                    <Glyphicon glyph={"plus-sign"} />
                </Button>
            </Panel.Heading>
            <Panel.Body className="panel-scroll">
                <div>
                    <TextareaWithLabel disabled value={token} label="_token_" />
                </div>
            </Panel.Body>
        </Panel>);
    }

    renderDeleteButton(list, item, cb) {
        return (
            <Button
                bsStyle="link"
                onClick={() => {
                    const position = list.indexOf(item);
                    list.splice(position, 1);
                    cb(list, position, item);
                }}>
                <Glyphicon glyph={"trash trash-button red-color"} />
            </Button>
        );
    }

    renderAddButton(list, item, cb) {
        return (
            <Button
                bsStyle="link"
                bsSize="xsmall"
                onClick={() => {
                    cb([...list, item]);
                }}>
                <Glyphicon glyph={"plus-sign"} />
            </Button>
        );
    }

    renderAccessList(field) {
        const { key, title } = field;
        const list = this.state[field.key] || [{ url: "", method: "" }];
        return (<Panel className="w-100" key={key}>
            <Panel.Heading>
                {translator.translate(title)}
                {this.renderAddButton(list, { url: "", method: "" }, (updated) => this.setState({ [key]: updated }))}
            </Panel.Heading>
            <Panel.Body className="panel-scroll">
                <div>
                    {list.map((permitted, i) => {
                        return (
                            <div className="flex-row" key={`${key}-${i}`}>
                                {this.renderPanelBody(key, permitted, i, list)}
                                <div>{list.length > 1 ? this.renderDeleteButton(list, permitted, (updated) => this.setState({ [key]: updated })) : null}</div>
                            </div>);
                    })}
                </div>
            </Panel.Body>
        </Panel>);
    }

    renderRequestField(field) {
        const { key, title } = field;
        const request = this.state[field.key] || { url: "", method: "" };
        return (<Panel className="w-100" key={key}>
            <Panel.Heading>
                {translator.translate(title)}
            </Panel.Heading>
            <Panel.Body className="panel-scroll">
                <div className="flex-row" key={key}>
                    {this.renderPanelBody(key, request)}
                </div>
            </Panel.Body>
        </Panel>);
    }

    renderPanelBody(key, request, i, list) {
        return (
            <React.Fragment>
                <div className="form-input-width url-margin">
                    <FormInput
                        label="_uri_"
                        name="uri"
                        value={request.url}
                        onChange={(e) => {
                            list ? list[i].url = e.target.value : request.url = e.target.value;
                            list ? this.setState({ [key]: list }) : this.setState({ [key]: request });
                            list ? this.props.setChangedData(key, request) : this.props.setChangedData(key, list);
                        }}
                        required={true} />
                </div>
                <div className="form-input-width">
                    <FormInput
                        label="_method_"
                        name="method"
                        value={request.method}
                        onChange={(e) => {
                            list ? list[i].method = e.target.value : request.method = e.target.value;
                            list ? this.setState({ [key]: list }) : this.setState({ [key]: request });
                            list ? this.props.setChangedData(key, list) : this.props.setChangedData(key, request);
                        }}
                        required={true} />
                </div>
            </React.Fragment>
        );
    }

    renderTemporaryPasswordField(field, id) {
        const key = field.key;
        const isRequired = field.isRequired === false ? false : (this.props.isNew ? true : !field.canChange.isPassword);
        const passwordVisible = !!this.state.passwordFieldVisible[key];
        const value = this.state[key] || "";
        const wrapperClassName = isRequired ? "required-field-wrapper" : "align-center";
        const btnStyles = { display: "flex", justifyContent: "end", columnGap: 10 };

        const expiryTimestamp = this.state.expiresAt;
        let expiryDisplay = null;
        let diff = 0;

        if (expiryTimestamp) {
            diff = new Date(expiryTimestamp) - Date.now();
        }

        if (expiryTimestamp) {
            if (diff <= 0) {
                expiryDisplay = (
                    <span style={{ color: "red", fontSize: 12 }}>
                    {translator.translate("Ժամկետանց")}
                </span>
                );
            } else {
                const validTime = translator.translate("_valid_time_");
                const totalSeconds = Math.floor(diff / 1000);
                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = totalSeconds % 60;

                let timeString = "";
                if (hours > 0) {
                    timeString += `${String(hours).padStart(2, "0")}:`;
                }
                timeString += `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

                expiryDisplay = (
                    <span style={{ color: "#FF0000", fontSize: 12 }}>
                    {`${validTime} ${timeString}`}
                </span>
                );
            }
        }

        return (
            <div key={id} className={wrapperClassName}>
                {expiryDisplay && <div>{expiryDisplay}</div>}
                <div className="align-center" style={{ gap: "10px" }}>
                    <div style={{ flex: 1 }}>
                        <FormInput
                            htmlFor={id}
                            label={field.title}
                            type={passwordVisible ? "text" : "password"}
                            id={key}
                            name={key}
                            value={value}
                            onChange={(e) => {
                                this.setState({ [key]: e.target.value });
                                this.props.setChangedData(key, e.target.value);
                            }}
                            onBlur={(e) => {
                                this.props.onBlur(key, e.target.value);
                            }}
                            required={isRequired}
                            showPasswordToggle
                            passwordVisible={passwordVisible}
                            onTogglePasswordVisibility={() => {
                                this.setState((prev) => ({
                                    passwordFieldVisible: {
                                        ...prev.passwordFieldVisible,
                                        [key]: !prev.passwordFieldVisible[key],
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
                <div style={btnStyles}>
                    {/* Generate random password */}
                    <Button
                        bsStyle="default"
                        className="btn-sm"
                        onClick={() => {
                            const password =
                                Math.random().toString(36).slice(-10) +
                                Math.random().toString(36).slice(-2);

                            this.setState({ [key]: password });
                            this.props.setChangedData(key, password);
                        }}
                    >
                        <Glyphicon glyph="glyphicon glyphicon-refresh" />

                    </Button>

                    <Button
                        bsStyle="primary"
                        className="btn-sm"
                        disabled={!value}
                        onClick={async () => {
                            try {
                                const response = await this.createTemporaryPassword();
                                const password = response.password;

                                this.setState({ [key]: password });
                                this.props.setChangedData(key, password);
                            } catch (error) {
                                console.error(error);
                            }
                        }}
                    >
                        {translator.translate("_generate_")}
                    </Button>
                </div>
            </div>
        );
    }

    renderInput(field, id) {
        const change = field.canChange;
        const user = this.props.userDetails.user;

        if (!change) {
            return null;
        }
        if (change.type === "accessToken") {
            return this.renderAccessToken(field, id);
        }
        if (change.type === "accessList") {
            return this.renderAccessList(field, id);
        }
        if (change.type === "request") {
            return this.renderRequestField(field, id);
        }
        if (change.type === "partner") {
            return this.renderPartnerField(field, id);
        }
        if (change.type === "userType") {
            return this.renderUserTypeField(field, id);
        }
        if (change.type === "extra") {
            return this.renderExtraFields(field, id);
        }
        if (change.type === "branch") {
            return this.renderBranchField(field, id);
        }
        if (change.type === "branch_call_center") {
            return this.renderBranchCallCenterField(field, id);
        }
        if (change.type === "contractDate") {
            return this.renderContractDate(field, id);
        }
        if (change.type === "tariff") {
            return this.renderTariffField(field, id);
        }
        if (change.type === "area") {
            return this.renderAreaField(field, id);
        }
        if (change.type === "apiUser") {
            return this.renderApiUserField(field, id);
        }
        if (change.type === "distributionPartner") {
            return this.renderDistributionPartnerField(field, id);
        }
        if (change.type === "taxRegime") {
            return this.renderTaxRegimeField(field, id);
        }
        if (change.type === "distributorCooperationType") {
            return this.renderDistributorCooperationTypes(field, id);
        }
        if (change.type === "terminalType") {
            return this.renderTerminalType(field, id);
        }
        if (change.type === "checkbox") {
            return this.renderCheckbox(field, id);
        }
        if (change.type === "temporaryPassword") {
            if (!user?._id || security.getUser().role != USER_ROLES.SUPER_ADMIN) {
                return null;
            }
            return this.renderTemporaryPasswordField(field, id);
        }
        const key = field.key;
        const isRequired = field.isRequired === false ? false : (this.props.isNew ? true : !change.isPassword);

        if (key === "receivableLimit" || key === "tipShare") {
            return this.percentageInput(field, id);
        }

        // Add a wrapper div with required class if needed
        const wrapperClassName = isRequired ? "required-field-wrapper" : "";

        const isPasswordField = change.type === "password" || change.type === "temporaryPassword";
        const passwordVisible = !!this.state.passwordFieldVisible[key];

        return (
            <div key={id} className={wrapperClassName}>
                <FormInput
                    htmlFor={id}
                    label={field.title}
                    type={isPasswordField && passwordVisible ? "text" : change.type}
                    id={key}
                    name={key}
                    value={this.state[key]}
                    onChange={(e) => {
                        this.setState({ [key]: e.target.value });
                        this.props.setChangedData(key, change.type === "number" ? Number(e.target.value) : e.target.value);
                    }}
                    onBlur={(e) => {
                        this.props.onBlur(key, e.target.value);
                    }}
                    validations={this.props.isNew && field.key === "terminalId" ? null : change.validations}
                    validationErrors={change.validationErrors}
                    required={isRequired}
                    disabled={key === "terminalId" || (field.isDisabled && this.props.isNew) || (key === "availableDebt" && security.getUser().role != USER_ROLES.SUPER_ADMIN)}
                    showPasswordToggle={isPasswordField}
                    passwordVisible={passwordVisible}
                    onTogglePasswordVisibility={isPasswordField ? () => {
                        this.setState((prev) => ({
                            passwordFieldVisible: {
                                ...prev.passwordFieldVisible,
                                [key]: !prev.passwordFieldVisible[key],
                            },
                        }));
                    } : undefined} />
            </div>
        );

    }

    render() {
        const user = this.props.userDetails.user;

        if (!user) {
            return null;
        }
        const role = this.props.userDetails.changedRole || user.role;

        if (!role) {
            return null;
        }
        const userColumns = rolesConf.user.getByRole(role);

        return (
            <div>
                {userColumns.map(this.renderInput.bind(this))}
            </div>
        );
    }
}

export default withFormsy(EditableField);
